import { ProfileButton } from "@/features/auth";
import { AppMenu } from "../components/AppMenu";
import { Outlet, useLocation } from "react-router-dom";

import { MobileHeader } from "@/shared/components/MobileHeader";
import { ResponsiveViewWrapper } from "@/shared/components/ResponsiveViewWrapper";
import { AdminBottomNavBar } from "../navigation/AdminBottomNavBar";
import { ADMIN_NAVIGATION } from "../navigation/admin-navigation";

/**
 * Shared mobile layout shell for the Admin Portal.
 * Wraps the main admin destinations; standalone join and message workflow pages own their own shells.
 *
 * Mirrors `TeacherPortalLayout` deliberately, including the `relative` body wrapper: that element
 * is the positioning context which keeps `absolute inset-0` overlays inside the phone frame rather
 * than letting them resolve against the whole desktop viewport.
 */
export function AdminPortalLayout() {
  const location = useLocation();

  const tabSubtitle =
    ADMIN_NAVIGATION.find(
      (tab) =>
        location.pathname === tab.path ||
        location.pathname.startsWith(`${tab.path}/`),
    )?.subtitle ?? ADMIN_NAVIGATION[0].subtitle;

  return (
    <ResponsiveViewWrapper
      maxMobileWidth={430}
      className="bg-frame-surface"
      scrollable={false}
      aria-label="پرتال مدیر"
    >
      {/* Mobile Top App Bar: no back button on the portal root, plus a logout action. */}
      <MobileHeader
        leadingAction={<ProfileButton />}
        title="کایرسافت"
        subtitle={tabSubtitle}
        showBack={false}
        trailingAction={<AppMenu />}
      />

      {/* Positioning context for any `absolute inset-0` overlay rendered by a child page. */}
      <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
        <div
          data-admin-scroll
          className="min-h-0 flex-1 space-y-3.5 overflow-x-hidden overflow-y-auto p-4 pb-28 select-none"
          dir="rtl"
        >
          <Outlet />
        </div>

        <AdminBottomNavBar />
      </div>
    </ResponsiveViewWrapper>
  );
}
